import {
  FileCheck2,
} from 'lucide-react'

export function EvidencePlugin() {
  return (
    <section className="module-card">
      <header>
        <div>
          <strong>
            Evidencias / Resultado
          </strong>

          <span>
            Contextual
          </span>
        </div>

        <FileCheck2 size={18} />
      </header>

      <p className="muted">
        Se activará cuando exista
        una ejecución, build, prueba,
        despliegue o rollback real.
      </p>
    </section>
  )
}
